// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DatabaseGroupSelectQueryVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
}>;

export type DatabaseGroupSelectQuery = {
  __typename?: "GraphqlQuery";
  getDatabaseGroups: Array<{
    __typename?: "DatabaseGroup";
    id: string;
    datname: string;
    hidden: boolean;
    databaseIds: Array<string>;
  }>;
};

export const DatabaseGroupSelectDocument = gql`
  query DatabaseGroupSelect($serverGroupId: ID!) {
    getDatabaseGroups(serverGroupId: $serverGroupId) {
      id
      datname
      hidden
      databaseIds
    }
  }
`;

/**
 * __useDatabaseGroupSelectQuery__
 *
 * To run a query within a React component, call `useDatabaseGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseGroupSelectQuery({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *   },
 * });
 */
export function useDatabaseGroupSelectQuery(
  baseOptions: Apollo.QueryHookOptions<
    DatabaseGroupSelectQuery,
    DatabaseGroupSelectQueryVariables
  > &
    (
      | { variables: DatabaseGroupSelectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DatabaseGroupSelectQuery,
    DatabaseGroupSelectQueryVariables
  >(DatabaseGroupSelectDocument, options);
}
export function useDatabaseGroupSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DatabaseGroupSelectQuery,
    DatabaseGroupSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DatabaseGroupSelectQuery,
    DatabaseGroupSelectQueryVariables
  >(DatabaseGroupSelectDocument, options);
}
// @ts-ignore
export function useDatabaseGroupSelectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DatabaseGroupSelectQuery,
    DatabaseGroupSelectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DatabaseGroupSelectQuery,
  DatabaseGroupSelectQueryVariables
>;
export function useDatabaseGroupSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DatabaseGroupSelectQuery,
        DatabaseGroupSelectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DatabaseGroupSelectQuery | undefined,
  DatabaseGroupSelectQueryVariables
>;
export function useDatabaseGroupSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DatabaseGroupSelectQuery,
        DatabaseGroupSelectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DatabaseGroupSelectQuery,
    DatabaseGroupSelectQueryVariables
  >(DatabaseGroupSelectDocument, options);
}
export type DatabaseGroupSelectQueryHookResult = ReturnType<
  typeof useDatabaseGroupSelectQuery
>;
export type DatabaseGroupSelectLazyQueryHookResult = ReturnType<
  typeof useDatabaseGroupSelectLazyQuery
>;
export type DatabaseGroupSelectSuspenseQueryHookResult = ReturnType<
  typeof useDatabaseGroupSelectSuspenseQuery
>;
export type DatabaseGroupSelectQueryResult = Apollo.QueryResult<
  DatabaseGroupSelectQuery,
  DatabaseGroupSelectQueryVariables
>;
